import LinearProgress from '@mui/material/LinearProgress';
import { styles } from './utils';

export type ProgressBarProps = {
  progress: number;
  className?: string;
};

export default function ProgressBar({ progress, className }: ProgressBarProps) {
  return (
    <LinearProgress
      sx={styles.progressBar}
      className={className}
      variant="determinate"
      value={progress}
    />
  );
}
